export default __webpack_public_path__ + "static/media/1.77b7fc38.png";